'use client';

import { useEffect } from 'react';

import { getUtag } from '../core';

import { useIsTrackerReady } from './use-is-tracker-ready';

import type { Utag } from '../core';

type UseUtagHook = (closure: (utag: Utag) => void, deps?: any[]) => void;

/**
 * Use utag when it's ready.
 *
 * ```tsx
 * useUtag(utag => {
 *   utag.link(...);
 * }, []);
 * ```
 */
export const useUtag: UseUtagHook = (closure, deps) => {
  const trackerReady = useIsTrackerReady();

  useEffect(
    () => {
      if (!trackerReady) {
        return;
      }

      const utag = getUtag(window);

      if (typeof utag === 'undefined') {
        return;
      }

      try {
        closure(utag);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Executing utag closure failed.', e);
      }
    },
    deps ? [trackerReady, ...deps] : undefined,
  );

  return;
};
